/* eslint-disable class-methods-use-this */
import {DOM} from './browser';
import {constants} from '../config/constants';

/**
 * Preloader
 *
 *
 */

export default class Preloader {
    /**
     * setting defaults for preloader element
    */
    get _defaults() {
        return {
            preloader: '.preloader',
            preloaderDesc: '.preloader__description',
            preloaderShow: 'preloader--show'
        };
    }

    constructor(el) {
        this.el = el || document.querySelector(`${this._defaults.preloader}`);
        this.elDesc = this.el.querySelector(`${this._defaults.preloaderDesc}`);
    }

    /**
     * @function show
     * @return undefined
     * @description show preloader when ajax request is made
    */
    show() {
        if(this.el){
            DOM.addClass(this.el, this._defaults.preloaderShow);
            this.elDesc.innerHTML = constants.PRODUCTS_LOADING;
        }
    }

    /**
     * @function hide
     * @return undefined
     * @description hide preloader when ajax request is completed
    */
    hide() {
        if(this.el){
            DOM.remClass(this.el, this._defaults.preloaderShow);
            this.elDesc.innerHTML = constants.PRODUCTS_LOADED;
        }
    }

    /**
     * @function toggle
     * @return undefined
     * @description toggling preloader when ajax request is made
    */
    toggle() {
        if(this.el){
            DOM.hasClass(this.el, this._defaults.preloaderShow) ?  this.hide() : this.show();
        }
    }
}


// WEBPACK FOOTER //
// /src/common/preloader.js